<template>
  <InputNumberWithPopover 
    v-bind="$attrs"
    v-on="{
      ...$listeners,
      input: handleInput,
      change: handleChange,
    }"
    :value="displayValue"
  />
</template>
<script>
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover.vue';

export default {
  name: 'InputNumberWithPopoverUpsell',
  components: { InputNumberWithPopover },
  props: {
    oldNumber: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    displayValue() {
      return this.value - this.oldNumber;
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value + this.oldNumber);
    },
    handleChange(value) {
      this.$emit('change', value + this.oldNumber);
    },
  },
};
</script>